import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE;

const Statistics = ({ userData, hasPermission }) => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const canViewSupportStats = hasPermission('manage_support') ||
                                hasPermission('view_team_management') ||
                                userData?.id === '293094387796279297' ||
                                userData?.roles?.includes('1451549682923864147');

    useEffect(() => {
        if (canViewSupportStats) {
            fetchSupportStats();
        }
    }, [canViewSupportStats]);

    const fetchSupportStats = async () => {
        try {
            setLoading(true);
            setError(null);
            const token = localStorage.getItem('discord_token');
            const response = await axios.get(`${API_BASE}/api/support-cases/stats`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                setStats(response.data.stats || []);
            } else {
                setError(response.data.error || 'Fehler beim Laden');
            }
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Server-Fehler');
        } finally {
            setLoading(false);
        }
    };

    const getSuccessRate = (solved, total) => (total === 0 ? 0 : Math.round((solved / total) * 100));

    if (!canViewSupportStats) {
        return <div className="card-body">Zugriff verweigert</div>;
    }

    return (
        <div className="dashboard-main">
            <div className="hero-panel">
                <h2 style={{ margin: 0 }}>📊 Support Performance</h2>
                <p className="muted small">Team-Statistiken der letzten 7 Tage</p>
            </div>

            <div className="grid">
                {/* Übersichtskarten */}
                <div className="card">
                    <div className="card-header"><h4>Übersicht</h4></div>
                    <div className="card-body">
                        <div className="stats-grid">
                            <div className="stat-item">
                                <div className="stat-number">
                                    {stats.reduce((sum, u) => sum + Number(u.total_cases || 0), 0)}
                                </div>
                                <div className="stat-label">Gesamt</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-number">
                                    {stats.reduce((sum, u) => sum + Number(u.solved_cases || 0), 0)}
                                </div>
                                <div className="stat-label">Gelöst</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-number">
                                    {stats.reduce((sum, u) => sum + Number(u.open_cases || 0), 0)}
                                </div>
                                <div className="stat-label">Offen</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Team Tabelle */}
                <div className="card">
                    <div className="card-header"><h4>Team-Mitglieder</h4></div>
                    <div className="card-body">
                        {loading ? (
                            <div className="spinner"></div>
                        ) : error ? (
                            <div style={{ color: '#ff4444' }}>⚠️ {error}</div>
                        ) : stats.length > 0 ? (
                            <div className="support-stats-table">
                                {stats.map((user) => (
                                    <div key={user.user_id} className="support-stat-row">
                                        <div className="stat-user-info">
                                            <div className="stat-user-name" style={{ fontWeight: 'bold', color: '#fff' }}>
                                                {user.user_name}
                                            </div>
                                            <div className="stat-user-id" style={{ fontSize: '0.75rem', opacity: 0.6 }}>
                                                {user.user_id}
                                            </div>
                                        </div>
                                        <div className="stat-metrics">
                                            <div className="stat-metric">
                                                <span className="metric-value">{user.total_cases}</span>
                                                <span className="metric-label">Fälle</span>
                                            </div>
                                            <div className="stat-metric">
                                                <span className="metric-value" style={{ color: '#00ff88' }}>{user.solved_cases}</span>
                                                <span className="metric-label">Gelöst</span>
                                            </div>
                                            <div className="stat-metric">
                                                <span className="metric-value">{getSuccessRate(user.solved_cases, user.total_cases)}%</span>
                                                <span className="metric-label">Erfolg</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>Keine Daten verfügbar.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Statistics;